"use strict";
/* Autogenerated file. Do not edit manually. */

/* tslint:disable */

/* eslint-disable */

var _classCallCheck = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BadERC721__factory = void 0;

var ethers_1 = require("ethers");

var BadERC721__factory = /*#__PURE__*/function (_ethers_1$ContractFac) {
  _inherits(BadERC721__factory, _ethers_1$ContractFac);

  var _super = _createSuper(BadERC721__factory);

  function BadERC721__factory(signer) {
    _classCallCheck(this, BadERC721__factory);

    return _super.call(this, _abi, _bytecode, signer);
  }

  _createClass(BadERC721__factory, [{
    key: "deploy",
    value: function deploy(overrides) {
      return _get(_getPrototypeOf(BadERC721__factory.prototype), "deploy", this).call(this, overrides || {});
    }
  }, {
    key: "getDeployTransaction",
    value: function getDeployTransaction(overrides) {
      return _get(_getPrototypeOf(BadERC721__factory.prototype), "getDeployTransaction", this).call(this, overrides || {});
    }
  }, {
    key: "attach",
    value: function attach(address) {
      return _get(_getPrototypeOf(BadERC721__factory.prototype), "attach", this).call(this, address);
    }
  }, {
    key: "connect",
    value: function connect(signer) {
      return _get(_getPrototypeOf(BadERC721__factory.prototype), "connect", this).call(this, signer);
    }
  }], [{
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
  }]);

  return BadERC721__factory;
}(ethers_1.ContractFactory);

exports.BadERC721__factory = BadERC721__factory;
var _abi = [{
  inputs: [{
    internalType: "bytes4",
    name: "_interface",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "nonpayable",
  type: "function"
}];
var _bytecode = "0x608060405234801561001057600080fd5b5060cf8061001f6000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c806301ffc9a714602d575b600080fd5b607560048036036020811015604157600080fd5b8101908080357bffffffffffffffffffffffffffffffffffffffffffffffffffffffff19169060200190929190505050608f565b604051808215151515815260200191505060405180910390f35b600080905091905056fea26469706673582212202a4ea99d2b1bff5d73baa98fce807afb16abb21199cdc2d99a8373d409b851d864736f6c63430006080033";